import React from "react";
import styled from "styled-components";
import { FaPhoneAlt, FaFacebook } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { RiInstagramFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import logoDark from "../assets/logoDark.png";
import logoLight from "../assets/logoLight.png";

const Footer = ({ theme }) => {
  return (
    <Container>
      <div className="top">
        <div className="logo">
          {theme === "dark" ? (
            <img src={logoDark} alt="" />
          ) : (
            <img src={logoLight} alt="" />
          )}
        </div>
        <div className="right">
          <div className="links">
            <h3>Links</h3>
            <Link to={"/"} className="link-styles">
              <p>Home</p>
            </Link>
            <Link to={"/prints"} className="link-styles">
              <p>Prints</p>
            </Link>
            <Link to={"/contact-us"} className="link-styles">
              <p>Contact Us</p>
            </Link>
            <Link to={"/about-us"} className="link-styles">
              <p>About Us</p>
            </Link>
          </div>
          <div className="contact">
            <div>
              <FaPhoneAlt className="icon" />
              <h3>+383 44 123 123</h3>
            </div>
            <div>
              <IoMail className="icon" />
              <h3>info@bp11-prints.com</h3>
            </div>
            <span>
              <Link to={"https://www.facebook.com/"} target="_blank">
                <FaFacebook className="icon" />
              </Link>
              <Link
                to={"https://www.instagram.com/bp11_artprint_kosova/"}
                target="_blank"
              >
                <RiInstagramFill className="icon" />
              </Link>
            </span>
          </div>
        </div>
      </div>
      {/* <div className="bottom">
        <p>Designed and Developed by:</p>
          <img src={ASitesLogo1} alt="" />
        <Link
          to={"https://asites-agency.web.app/"}
          className="link-styles"
          target="_blank"
        >
          <p>Visit ASites Agency</p>
        </Link>
      </div> */}
    </Container>
  );
};
const Container = styled.div`
  padding: 3em 4%;
  background: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  box-shadow: 0 0 12px 1px var(--fontSecondaryColor);
  .top {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .logo {
      img {
        width: 300px;
      }
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4em;
      .links {
        display: flex;
        flex-direction: column;
        gap: 10px;
        h3 {
          font-weight: 500;
        }
        p {
          color: var(--fontSecondaryColor);
          font-weight: 300;
        }
      }
      .contact {
        display: flex;
        flex-direction: column;
        gap: 1em;
        div {
          display: flex;
          align-items: center;
          gap: 10px;
          .icon {
            font-size: 3em;
            background: var(--fontPrimaryColor);
            color: var(--primaryBackgroundColor);
            padding: 10px;
            border-radius: 10px;
          }
          h3 {
            font-weight: 300;
            color: var(--fontSecondaryColor);
          }
        }
        span {
          display: flex;
          gap: 10px;
          .icon {
            font-size: 3em;
            padding: 10px;
            border-radius: 10px;
            background: var(--fontPrimaryColor);
            color: var(--primaryBackgroundColor);
          }
        }
      }
    }
  }
  .bottom {
    margin-top: 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    p {
      color: var(--fontSecondaryColor);
      font-weight: 300;
      text-align: center;
    }
    img {
      width: 200px;
    }
  }
  @media (max-width: 700px) {
    .top {
      flex-direction: column;
      gap: 3em;
      align-items: center;
      .right {
        flex-wrap: wrap;
        div {
          flex-wrap: wrap;
        }
      }
    }
  }
`;

export default Footer;
